<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外管工作台</Breadcrumb-item>
        <Breadcrumb-item>新外教跟进</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="rule-bar">
      <span class="rule-dot"></span>
      规则：新外教入职满 <b>{{ rules.reviewDays }}</b> 天触发一次回访（节点日 = 入职日 + {{ rules.reviewDays }} 天）；节点前
      <b>{{ rules.reviewAlertDays }}</b> 天开始提示，逾期未登记持续提醒。入职早于 <b>{{ rules.reviewStartDate || '—' }}</b> 的老师不进清单。
      <a href="javascript:;" @click="$router.push('/hrWorkbench/settings')">调整规则</a>
    </div>
    <div class="filter-bar">
      <span class="toolbar-label">外教运营</span>
      <adviser-select v-model="adviserId" @on-change="onAdviserChange"></adviser-select>
      <Button-group class="seg">
        <Button v-for="item in levelTabs" :key="item.value"
                :type="level === item.value ? 'primary' : 'ghost'"
                @click="changeLevel(item.value)">
          {{ item.label }} {{ counts[item.value] || 0 }}
        </Button>
      </Button-group>
      <span class="toolbar-total">共 {{ dataList.length }} 人</span>
      <Button class="export-btn" @click="exportCsv">导出</Button>
    </div>
    <div class="list-table">
      <Table :columns="columns" :data="dataList" :loading="searchLoading" stripe
             :row-class-name="rowClassName" no-data-text="当前筛选下无回访对象"></Table>
    </div>
    <review-save-modal :value="showReview" :row="currentRow"
                       @on-close="showReview = false" @on-success="search"></review-save-modal>
    <tch-info-modal :value="showTchInfoModal" :tchId="tchInfoId" @on-close="showTchInfoModal = false"></tch-info-modal>
  </div>
</template>
<script>
import AdviserSelect from './AdviserSelect.vue'
import ReviewSaveModal from './modal/ReviewSaveModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { API_PREFIX, REVIEW_LEVEL, REVIEW_RESULT, codeText, codeColor, tchLabel, adviserParam, downloadCsv, resolveAdviserId, writeStoredAdviserId} from './constants'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
const LEVEL_KEYS = ['open', 'overdue', 'soon', 'done', 'all']
export default {
  name: 'HrWorkbenchReview',
  components: { AdviserSelect, ReviewSaveModal, TchInfoModal },
  data () {
    let q = this.$route.query || {}
    return {
      adviserId: resolveAdviserId(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      levelTabs: [
        { value: 'open', label: '待回访' },
        { value: 'overdue', label: '已逾期' },
        { value: 'soon', label: '即将' },
        { value: 'done', label: '已完成' },
        { value: 'all', label: '全部' }
      ],
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showReview: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    }
  },
  created () {
    writeStoredAdviserId(this.adviserId)
    this.$root.$emit('hr-badges-refresh')

    let self = this
    this.columns = [
      {
        title: '外教',
        key: 'tchName',
        width: 200,
        render: (h, params) => self.renderTch(h, params.row)
      },
      {
        title: '外教运营',
        key: 'studyAdviserName',
        width: 140,
        render: (h, params) => h('span', params.row.studyAdviserName || '未分配')
      },
      {
        title: '入职日期',
        key: 'hireDate',
        width: 110,
        render: (h, params) => h('span', params.row.hireDate || '—')
      },
      {
        title: '回访节点日',
        key: 'reviewDue',
        width: 110,
        render: (h, params) => h('span', params.row.reviewDue || '—')
      },
      {
        title: '距节点(天)',
        key: 'daysLeft',
        width: 95,
        align: 'center',
        render: (h, params) => {
          let row = params.row
          if (row.level === 'done' || row.daysLeft == null) {
            return h('span', { class: 'muted' }, '—')
          }
          return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft)
        }
      },
      {
        title: '状态',
        key: 'level',
        width: 110,
        render: (h, params) => h('Tag', { props: { color: codeColor(REVIEW_LEVEL, params.row.level) } }, codeText(REVIEW_LEVEL, params.row.level) || '—')
      },
      {
        title: '最近回访结论',
        key: 'lastReview',
        width: 160,
        render: (h, params) => {
          let r = params.row.lastReview
          if (!r) {
            return h('span', { class: 'muted' }, '—')
          }
          return h('div', { class: 'tch-cell' }, [
            h('Tag', { props: { color: codeColor(REVIEW_RESULT, r.result) } }, codeText(REVIEW_RESULT, r.result) || '—'),
            h('div', { class: 'muted' }, (r.reviewDate || '') + ' · ' + (r.channel || '') + (r.creatorName ? ' · ' + r.creatorName : ''))
          ])
        }
      },
      {
        title: '回访记录',
        key: 'note',
        width: 220,
        render: (h, params) => {
          let r = params.row.lastReview
          if (!r || (!r.note && !r.nextAction)) {
            return h('span', { class: 'muted' }, '—')
          }
          return h('div', [
            r.note ? h('div', r.note) : null,
            r.nextAction ? h('div', { class: 'muted' }, '后续：' + r.nextAction) : null
          ])
        }
      },
      {
        title: '操作',
        key: 'action',
        width: 190,
        align: 'center',
        render: (h, params) => {
          let row = params.row
          let done = !!row.lastReview
          return h('div', [
            h('Button', {
              props: { size: 'small' },
              on: { click: () => self.openTchInfo(row.tchId) }
            }, '档案'),
            h('Button', {
              props: { type: done ? 'ghost' : 'primary', size: 'small' },
              style: { marginLeft: '6px' },
              on: { click: () => self.openReview(row) }
            }, done ? '更新回访' : '登记回访')
          ])
        }
      }
    ]
  },
  mounted () {
    this.search()
  },
  methods: {
    renderTch (h, row) {
      let self = this
      return h('div', { class: 'tch-cell' }, [
        renderTchNameWithScore(h, {
          text: tchLabel(row),
          score: row.monthRankScore,
          onClick: () => self.openTchInfo(row.tchId)
        }),
        h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))
      ])
    },
    rowClassName (row) {
      return row.level === 'overdue' ? 'row-danger' : ''
    },
    changeLevel (level) {
      this.level = level
      this.search()
    },
    onAdviserChange () {
      writeStoredAdviserId(this.adviserId)
      this.$root.$emit('hr-badges-refresh')
      this.search()
    },
    search () {
      let self = this
      let params = Object.assign({ level: self.level }, adviserParam(self.adviserId))
      self.searchLoading = true
      self.$http.post(API_PREFIX + '/review/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {}
          self.rules = res.data.rules || {}
          self.dataList = res.data.rows || []
          self.loadMonthRankScores()
        } else {
          self.dataList = []
        }
      }).finally(function () {
        self.searchLoading = false
      })
    },
    loadMonthRankScores () {
      const rows = this.dataList || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    openReview (row) {
      this.currentRow = row
      this.showReview = true
    },
    openTchInfo (tchId) {
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    },
    tchExport (row) {
      return tchLabel(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '')
    },
    daysExport (row) {
      if (row.level === 'done' || row.daysLeft == null) {
        return '—'
      }
      return row.daysLeft
    },
    lastExport (row) {
      let r = row.lastReview
      if (!r) {
        return '—'
      }
      return (codeText(REVIEW_RESULT, r.result) || '—') + ' ' + (r.reviewDate || '') + ' · ' + (r.channel || '') + (r.creatorName ? ' · ' + r.creatorName : '')
    },
    noteExport (row) {
      let r = row.lastReview
      if (!r || (!r.note && !r.nextAction)) {
        return '—'
      }
      let parts = []
      if (r.note) {
        parts.push(r.note)
      }
      if (r.nextAction) {
        parts.push('后续：' + r.nextAction)
      }
      return parts.join(' ')
    },
    exportCsv () {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据')
        return
      }
      let self = this
      let rows = this.dataList.map(function (row) {
        let done = !!row.lastReview
        return [
          self.tchExport(row),
          row.studyAdviserName || '未分配',
          row.hireDate || '—',
          row.reviewDue || '—',
          self.daysExport(row),
          codeText(REVIEW_LEVEL, row.level) || '—',
          self.lastExport(row),
          self.noteExport(row),
          '档案 ' + (done ? '更新回访' : '登记回访')
        ]
      })
      downloadCsv('新外教跟进.csv', ['外教', '外教运营', '入职日期', '回访节点日', '距节点(天)', '状态', '最近回访结论', '回访记录', '操作'], rows)
    }
  }
}
</script>
<style scoped lang="less">
.rule-bar {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f8f8f9;
  border-radius: 4px;
  line-height: 22px;
  font-size: 12px;
  color: #495060;
}
.rule-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background: #2d8cf0;
}
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.toolbar-label {
  color: #495060;
}
.toolbar-total {
  color: #80848f;
  font-size: 12px;
}
.export-btn {
  margin-left: auto;
}
.list-table /deep/ .muted {
  color: #80848f;
  font-size: 12px;
}
.list-table /deep/ .text-danger {
  color: #E6464E;
}
.list-table /deep/ .tch-cell {
  padding: 4px 0;
}
.list-table /deep/ .ivu-table .row-danger td {
  background: #fff5f5;
}
</style>



// WEBPACK FOOTER //
// HrWorkbenchReview.vue?1a61d9ce